/* =====================================================================
   Pritec demo-pagina — pr-demo.js
   - Video-facades (YouTube pas laden na klik, via youtube-nocookie.com)
   - Hero-video afspelen / sluiten
   - Tabs in de videobibliotheek
   - Demo-popup: Calendly verborgen tot iemand op 'Demo aanvragen' klikt,
     dan gecentreerd in een <dialog> met donkere achtergrond.
     Sluiten met het kruisje, Esc of een klik naast de popup.
   - Zwevende knop 'Demo aanvragen' (na de hero, naast de chat)
   - dataLayer-events: demo_cta_click en video_start (geen lead-event:
     de boeking zelf meet je al via Calendly)
   Alle zichtbare teksten komen uit de secties (vertaalbaar via
   Translate & Adapt). Dit bestand bevat geen zichtbare tekst.
   ===================================================================== */
(function () {
  'use strict';

  // Elke sectie laadt dit bestand; zorg dat het maar één keer draait.
  if (window.__prDemoLoaded) return;
  window.__prDemoLoaded = true;

  var CALENDLY_SRC = 'https://assets.calendly.com/assets/external/widget.js';

  /* ---------- Hulpjes ---------- */
  function track(eventName, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    if (data) {
      Object.keys(data).forEach(function (key) {
        if (data[key]) payload[key] = data[key];
      });
    }
    window.dataLayer.push(payload);
  }

  /* ---------- YouTube-facades ---------- */
  function youtubeSrc(id) {
    return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
  }

  function makeIframe(id, title) {
    var iframe = document.createElement('iframe');
    iframe.src = youtubeSrc(id);
    iframe.title = title || '';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    return iframe;
  }

  function playFacade(box) {
    var id = box.getAttribute('data-pr-yt');
    if (!id || box.classList.contains('is-playing')) return;
    box.__prFacade = box.innerHTML;
    box.innerHTML = '';
    box.appendChild(makeIframe(id, box.getAttribute('data-title')));
    box.classList.add('is-playing');
    track('video_start', {
      video_title: box.getAttribute('data-title'),
      use_case: box.getAttribute('data-use-case')
    });
  }

  function resetFacades(scope) {
    scope.querySelectorAll('[data-pr-yt].is-playing').forEach(function (box) {
      if (box.__prFacade) box.innerHTML = box.__prFacade;
      box.classList.remove('is-playing');
    });
  }

  /* ---------- Hero-video ---------- */
  function playHero(hero) {
    if (!hero || hero.classList.contains('is-playing')) return;
    var player = hero.querySelector('[data-pr-hero-player]');
    if (!player) return;
    var template = hero.querySelector('template[data-pr-hero-video]');
    var youtubeId = hero.getAttribute('data-yt');
    player.innerHTML = '';

    if (template) {
      player.appendChild(template.content.cloneNode(true));
      var video = player.querySelector('video');
      if (video) {
        video.controls = true;
        video.playsInline = true;
        video.muted = false;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      }
    } else if (youtubeId) {
      player.appendChild(makeIframe(youtubeId, hero.getAttribute('data-title')));
    } else {
      return;
    }

    hero.classList.add('is-playing');
    var close = hero.querySelector('[data-pr-hero-close]');
    if (close) close.focus({ preventScroll: true });
    track('video_start', { video_title: hero.getAttribute('data-title'), use_case: 'hero' });
  }

  function stopHero(hero) {
    if (!hero) return;
    var player = hero.querySelector('[data-pr-hero-player]');
    if (player) player.innerHTML = '';
    hero.classList.remove('is-playing');
    var play = hero.querySelector('[data-pr-hero-play]');
    if (play) play.focus({ preventScroll: true });
  }

  /* ---------- Tabs ---------- */
  function selectTab(tab, moveFocus) {
    var list = tab.closest('[data-pr-tabs]');
    if (!list) return;
    list.querySelectorAll('[data-pr-tab]').forEach(function (item) {
      var active = item === tab;
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.tabIndex = active ? 0 : -1;
      var panel = document.getElementById(item.getAttribute('aria-controls'));
      if (!panel) return;
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
        resetFacades(panel);
      }
    });
    if (moveFocus) tab.focus();
  }

  function onTabKey(event, tab) {
    var tabs = Array.prototype.slice.call(tab.closest('[data-pr-tabs]').querySelectorAll('[data-pr-tab]'));
    var index = tabs.indexOf(tab);
    var next = null;
    if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
    if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
    if (event.key === 'Home') next = tabs[0];
    if (event.key === 'End') next = tabs[tabs.length - 1];
    if (next) {
      event.preventDefault();
      selectTab(next, true);
    }
  }

  /* ---------- Calendly ---------- */
  var calendlyPromise = null;

  function loadCalendlyScript() {
    if (window.Calendly && window.Calendly.initInlineWidget) return Promise.resolve();
    if (calendlyPromise) return calendlyPromise;
    calendlyPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = CALENDLY_SRC;
      script.async = true;
      script.onload = function () {
        if (window.Calendly && window.Calendly.initInlineWidget) resolve();
        else reject(new Error('Calendly niet beschikbaar'));
      };
      script.onerror = function () {
        calendlyPromise = null;
        reject(new Error('Calendly-script niet geladen'));
      };
      document.head.appendChild(script);
    });
    return calendlyPromise;
  }

  function utmFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var map = {
      utm_campaign: 'utmCampaign',
      utm_source: 'utmSource',
      utm_medium: 'utmMedium',
      utm_content: 'utmContent',
      utm_term: 'utmTerm'
    };
    var utm = {};
    Object.keys(map).forEach(function (key) {
      var value = params.get(key);
      if (value) utm[map[key]] = value;
    });
    return utm;
  }

  // Laadt Calendly in de popup. Gebeurt pas bij de eerste keer openen.
  function loadAgenda(modal) {
    if (!modal || modal.__prLoaded) return;
    modal.__prLoaded = true;

    var embed = modal.querySelector('[data-pr-agenda-embed]');
    var loading = modal.querySelector('[data-pr-agenda-loading]');
    var fallback = modal.querySelector('[data-pr-agenda-fallback]');
    var url = modal.getAttribute('data-url');
    var timer = null;

    function showFallback() {
      clearTimeout(timer);
      if (loading) loading.setAttribute('hidden', '');
      if (embed) embed.setAttribute('hidden', '');
      if (fallback) fallback.removeAttribute('hidden');
    }

    function ready() {
      clearTimeout(timer);
      if (loading) loading.setAttribute('hidden', '');
      if (fallback) fallback.setAttribute('hidden', '');
      if (embed) {
        embed.removeAttribute('hidden');
        embed.setAttribute('aria-busy', 'false');
      }
    }

    if (!url || !embed) {
      showFallback();
      return;
    }

    // Geen agenda binnen 12 seconden (cookiebanner blokkeert, netwerk traag): toon het alternatief.
    timer = setTimeout(showFallback, 12000);

    loadCalendlyScript()
      .then(function () {
        window.Calendly.initInlineWidget({
          url: url,
          parentElement: embed,
          utm: utmFromUrl()
        });
        var iframe = embed.querySelector('iframe');
        if (iframe) {
          iframe.title = modal.getAttribute('data-iframe-title') || '';
          iframe.addEventListener('load', ready, { once: true });
        } else {
          ready();
        }
      })
      .catch(showFallback);
  }

  /* ---------- Popup ---------- */
  var MODAL_HASH = '#demo-aanvragen';
  var lastTrigger = null;

  function getModal() {
    return document.querySelector('[data-pr-modal]');
  }

  function lockScroll() {
    var root = document.documentElement;
    var scrollbar = window.innerWidth - root.clientWidth;
    if (scrollbar > 0) root.style.setProperty('--pr-scrollbar', scrollbar + 'px');
    root.classList.add('pr-modal-lock');
  }

  function unlockScroll() {
    var root = document.documentElement;
    root.classList.remove('pr-modal-lock');
    root.style.removeProperty('--pr-scrollbar');
  }

  // Geeft false terug als de browser geen <dialog> kent (dan openen we Calendly in een nieuw tabblad).
  function openModal(modal, trigger) {
    if (modal.open) return true;
    if (typeof modal.showModal !== 'function') return false;
    lastTrigger = trigger || document.activeElement;
    modal.showModal();
    lockScroll();
    loadAgenda(modal);
    // Focus op de titel: schermlezers lezen dan eerst voor waar je bent.
    var title = modal.querySelector('[data-pr-modal-title]');
    if (title) title.focus({ preventScroll: true });
    return true;
  }

  function closeModal(modal) {
    if (modal && modal.open) modal.close();
  }

  function setupModal(modal) {
    if (modal.__prInit) return;
    modal.__prInit = true;

    // Klik op de donkere achtergrond sluit de popup. De klik moet daar ook begonnen zijn,
    // zodat tekst selecteren en buiten loslaten de popup niet per ongeluk sluit.
    var downOnBackdrop = false;
    modal.addEventListener('pointerdown', function (event) {
      downOnBackdrop = event.target === modal;
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal && downOnBackdrop) closeModal(modal);
      downOnBackdrop = false;
    });

    // Esc sluit de popup vanzelf (standaardgedrag van <dialog>). Hier ruimen we op.
    modal.addEventListener('close', function () {
      unlockScroll();
      if (window.location.hash === MODAL_HASH && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      if (lastTrigger && lastTrigger.focus && document.contains(lastTrigger)) {
        lastTrigger.focus({ preventScroll: true });
      }
      lastTrigger = null;
    });
  }

  function onDemoCta(event, cta) {
    track('demo_cta_click', { cta_location: cta.getAttribute('data-location') });
    var modal = getModal();
    if (!modal) return; // geen popup op deze pagina: laat de link gewoon werken
    event.preventDefault();
    if (!openModal(modal, cta)) {
      var url = modal.getAttribute('data-page-url');
      if (url) window.open(url, '_blank', 'noopener');
    }
  }

  /* ---------- Zwevende knop: zichtbaar na de hero, weg bij de footer ---------- */
  function setupBar(bar) {
    if (bar.__prInit) return;
    bar.__prInit = true;

    var hero = document.querySelector('[data-pr-hero]');
    var footer = document.querySelector('.shopify-section-group-footer-group, #shopify-section-footer, footer');
    var state = { hero: !!hero, footer: false };

    function apply() {
      bar.classList.toggle('is-visible', !state.hero && !state.footer);
    }

    if (!('IntersectionObserver' in window)) {
      state.hero = false;
      apply();
      return;
    }
    if (hero) {
      new IntersectionObserver(function (entries) {
        state.hero = entries[0].isIntersecting;
        apply();
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(hero);
    }
    if (footer) {
      new IntersectionObserver(function (entries) {
        state.footer = entries[0].isIntersecting;
        apply();
      }).observe(footer);
    }
    apply();
  }

  /* ---------- Events (gedelegeerd, werkt ook na herladen in de theme-editor) ---------- */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var closeButton = target.closest('[data-pr-modal-close]');
    if (closeButton) {
      event.preventDefault();
      closeModal(closeButton.closest('[data-pr-modal]'));
      return;
    }
    var facadeButton = target.closest('.pr-video__btn');
    if (facadeButton) {
      event.preventDefault();
      playFacade(facadeButton.closest('[data-pr-yt]'));
      return;
    }
    var heroPlay = target.closest('[data-pr-hero-play]');
    if (heroPlay) {
      event.preventDefault();
      playHero(heroPlay.closest('[data-pr-hero]'));
      return;
    }
    var heroClose = target.closest('[data-pr-hero-close]');
    if (heroClose) {
      event.preventDefault();
      stopHero(heroClose.closest('[data-pr-hero]'));
      return;
    }
    var tab = target.closest('[data-pr-tab]');
    if (tab) {
      selectTab(tab, false);
      return;
    }
    var openInTab = target.closest('[data-pr-agenda-open]');
    if (openInTab) {
      track('demo_cta_click', { cta_location: 'agenda_fallback' });
      return; // link opent Calendly gewoon in een nieuw tabblad
    }
    var cta = target.closest('[data-pr-demo-cta]');
    if (cta) onDemoCta(event, cta);
  });

  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('[data-pr-tab]')) {
      onTabKey(event, target.closest('[data-pr-tab]'));
      return;
    }
    if (event.key === 'Escape') {
      var modal = getModal();
      if (modal && modal.open) return; // de popup sluit zichzelf
      var playing = document.querySelector('[data-pr-hero].is-playing');
      if (playing) stopHero(playing);
    }
  });

  function init() {
    document.querySelectorAll('[data-pr-modal]').forEach(setupModal);
    document.querySelectorAll('[data-pr-bar]').forEach(setupBar);
    // Na herladen van een sectie in de editor: geen popup meer open, dan ook de pagina weer scrollbaar.
    var modal = getModal();
    if (!modal || !modal.open) unlockScroll();
  }

  function openFromHash() {
    if (window.location.hash !== MODAL_HASH) return;
    var modal = getModal();
    if (modal) openModal(modal, null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      openFromHash();
    });
  } else {
    init();
    openFromHash();
  }
  // Link naar /pages/demo#demo-aanvragen (menu, mail, advertentie) opent direct de popup.
  window.addEventListener('hashchange', openFromHash);

  /* ---------- Theme-editor: popup open zolang je de sectie bewerkt ---------- */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', function (event) {
    var modal = event.target && event.target.querySelector && event.target.querySelector('[data-pr-modal]');
    if (modal) {
      setupModal(modal);
      openModal(modal, null);
    }
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    var modal = event.target && event.target.querySelector && event.target.querySelector('[data-pr-modal]');
    if (modal) closeModal(modal);
  });
})();